import TableRow, { ITableRow } from './TableRow';

export type { ITableRow };
export default TableRow;
